// Mirrors backend profit formula; works in paise (integers) to avoid float drift.
const p = (v) => Math.round((parseFloat(v) || 0) * 100);

export const PROFIT_FIELDS = [
  "earning_for_shop",
  "price_to_shop",
  "dc_collected",
  "dc_payable",
  "dc_from_shop",
  "min_guarantee",
  "other_expense",
];

export function computeProfit(form) {
  const efs = p(form.earning_for_shop);
  const totalDc = p(form.dc_collected) + p(form.dc_from_shop);
  const dcLoss = totalDc - p(form.dc_payable);
  const totalCommission = efs - p(form.price_to_shop);
  const ciboee = Math.round(efs * 0.05);
  const mg = p(form.min_guarantee);
  const final = totalCommission - ciboee - dcLoss - mg - p(form.other_expense);
  const r = (x) => x / 100;
  return {
    total_dc_collected: r(totalDc),
    dc_loss: r(dcLoss),
    total_commission: r(totalCommission),
    ciboee_commission: r(ciboee),
    min_guarantee: r(mg),
    final_profit: r(final),
  };
}

export const FORMULA_LINES = [
  "Total DC Collected = DC Collected + DC from Shop",
  "DC Loss = Total DC Collected − DC Payable",
  "Total Commission = Earning for Shop − Price to Shop",
  "Ciboee Commission = 5% × Earning for Shop",
  "Final Profit = Total Commission − Ciboee Commission − DC Loss − Minimum Guarantee (manual) − Other Expense",
];
